import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';
// import _default from '../../themes/default';

export const Nav = styled.div`
    background: linear-gradient(135deg, ${({ theme }) => theme.card_light} 0%, ${({ theme }) => theme.card} 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(133, 76, 230, 0.15);
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, #854CE6, #FF6B6B, #9d5ce8);
        opacity: 0.9;
    }
    
    @media (max-width: 960px) {
        transition: 0.8s all ease;
        backdrop-filter: blur(15px);
    }
`;
export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;

export const NavLogo = styled(LinkR)`
    width: 80%;    
    padding: 0 6px;
    display: flex;
    justify-content: start;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
        transform: scale(1.02);
    }
    
    @media (max-width: 640px) {
        padding: 0 0px;
    }
`;
export const Span = styled.div`
    padding: 0 4px;
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.text_primary};
    transition: all 0.3s ease;
    border-bottom: 2px solid #854CE6;
    padding-bottom: 2px;
    
    @media (max-width: 768px) {
        font-size: 18px;
    }
`;
export const NavItems = styled.ul`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content:center;
    gap: 32px;
    padding: 0 6px;
    list-style: none;

    @media screen and (max-width: 768px) {
      display: none;
    }
`;

export const NavLink = styled.a`
    color: ${({ theme }) => theme.text_primary};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    padding: 8px 16px;
    border-radius: 12px;
    position: relative;
    
    &:hover {
        color: #FF6B6B;
        background: rgba(255, 107, 107, 0.08);
        transform: translateY(-1px);
    }

    &.active {
        color: #FF6B6B;
        background: rgba(255, 107, 107, 0.12);
        border-bottom: 2px solid #FF6B6B;
    }
`;


export const GitHubButton = styled.a`
  border: 1.5px solid rgba(133, 76, 230, 0.3);
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 16px;
  color: ${({ theme }) => theme.text_primary};
  cursor: pointer;
  padding: 0 18px;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(133, 76, 230, 0.05);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, #854CE6, #9d5ce8);
    color: ${({ theme }) => theme.white};
    border-color: #854CE6;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(133, 76, 230, 0.3);
    
    &::before {
      left: 100%;
    }
  }
  
  @media screen and (max-width: 768px) { 
    font-size: 13px;
    padding: 0 14px;
  }
`;

export const ButtonContainer = styled.div`
  width: 80%;  
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 6px;
  gap: 12px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;


export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.5rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text_primary};
  }
`

export const MobileMenu = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    position: absolute;
    top: 80px;
    right: 0;
    width: 100%;
    padding: 20px 40px 30px 40px;
    background: linear-gradient(135deg, ${({ theme }) => theme.card_light}f0 0%, ${({ theme }) => theme.card}f0 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-100%)')};
    border-radius: 0 0 24px 24px;
    border: 1px solid rgba(133, 76, 230, 0.1);
    border-top: none;
    box-shadow: 0 16px 48px rgba(133, 76, 230, 0.2);
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    z-index: ${({ isOpen }) => (isOpen ? '1000' : '-1000')};
`;

export const MobileMenuItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  list-style: none;
  width: 100%;
  height: 100%;
`

export const MobileMenuLink = styled(LinkR)`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }

  &.active {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;

export const MobileMenuButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }
`;

export const MobileLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  padding: 12px 16px;
  border-radius: 12px;
  text-align: center;
  
  &:hover {
    color: #FF6B6B;
    background: rgba(255, 107, 107, 0.1);
    transform: translateX(4px);
  }

  &.active {
    color: #FF6B6B;
    background: rgba(255, 107, 107, 0.15);
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;

export const MobileNavLogo = styled(LinkR)`
  width: 80%;
  padding: 0 6px;
  display: flex;
  justify-content: start;
  align-items: center;
  text-decoration: none;
  @media (max-width: 640px) {
    padding: 0 0px;
  }
`;